import React from 'react';
import { ParallaxScene, ParallaxLayer } from './ParallaxScene';

/**
 * PageHero — bandeau visuel harmonisé pour les onglets principaux (Dashboard,
 * Contacts, Organisations, Opportunités, Dossiers…). Parallax léger + micro-blobs
 * colorés + titre/subtitle. Compact (hauteur ~ 130px).
 *
 * Props:
 * - title: string (obligatoire)
 * - subtitle: string
 * - icon: JSX (Phosphor icon)
 * - gradient: string tailwind (ex: "from-[#2D5A4C] to-[#00AEEF]")
 * - accents: [color1, color2] pour blobs (défaut : cyan + lime)
 * - actions: JSX à afficher à droite
 */
export function PageHero({ title, subtitle, icon, gradient = 'from-[#2D5A4C] to-[#1E4136]', accents = ['#00AEEF', '#80C51F'], actions }) {
  return (
    <ParallaxScene className={`relative overflow-hidden rounded-2xl bg-gradient-to-br ${gradient} text-white shadow-lg`} data-testid="page-hero">
      <ParallaxLayer depth={0.06} className="absolute -top-8 -right-8 w-40 h-40 rounded-full opacity-30 blur-2xl" style={{ background: accents[0] }} />
      <ParallaxLayer depth={0.04} className="absolute -bottom-10 left-16 w-32 h-32 rounded-full opacity-25 blur-2xl" style={{ background: accents[1] }} />
      <div className="relative p-5 md:p-6 flex items-center gap-4 flex-wrap">
        {icon && (
          <div className="w-12 h-12 rounded-xl bg-white/15 backdrop-blur border border-white/20 flex items-center justify-center shrink-0">
            {icon}
          </div>
        )}
        <div className="flex-1 min-w-0 motion-fade-up">
          <h1 className="text-2xl md:text-3xl font-extrabold leading-tight" style={{ fontFamily: 'Manrope' }}>{title}</h1>
          {subtitle && <p className="text-sm md:text-base text-white/85 mt-0.5">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
    </ParallaxScene>
  );
}

export default PageHero;
